// @ts-check
/**
 * Typed client for the care-management patient search API.
 *
 * The POST form keeps search criteria, which can contain PHI, out of URLs.
 * Types are generated from the backend OpenAPI schema; regenerate them with:
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['PatientSearchRequest']} PatientSearchRequest */
/** @typedef {Schemas['PatientSearchResult']} PatientSearchResult */

/**
 * Search care-management patients by text, date of birth, or both.
 *
 * @param {PatientSearchRequest} body
 * @returns {Promise<PatientSearchResult[]>}
 */
export async function searchPatients(body) {
  const { data } = await axios.post('/api/care-management/patient-search/', body)
  return data
}
